<template>
   <div id="inside" style="" :style="largura > 500 ? 'min-height: 685px;': 'min-height: 480px;'">
     
    <div class="container">
      <div class="row">
        <div class="">
        </div>
        <div class="btn-group btn-group-sm">
            <a
              href="/"
              class="btn btn-link d-flex flex-column justify-content-center text-secondary"
              ><i class="fa fa-home fa-fw fa-lg"></i>
            </a>
            <router-link
              to="/dashboard"
              ><a href="/dashboard" class="btn btn-link text-secondary" style="text-decoration: none; cursor: initial;">Meus contratos</a>
            </router-link>
            <router-link
              to="#"
              ><a href="#" class="btn btn-link text-secondary" style="text-decoration: none; cursor: initial;">Negociar Dívidas</a>
            </router-link>
        </div>
        <div class="col-md-12">
            <h1>Contratos disponíveis</h1>
            <p class="text-muted">Selecione os contratos que deseja negociar. Após selecionar, clique em "negociar" para prosseguir.</p>
        </div>      
      </div>
    </div>

    <div class="container" v-if="!loadDeal">
      <div class="row border-top border-info mx-10 pt-5 pl-0 ml-0 mb-4 justify-content-between align-items-end">
        <div class="row col-7 col-mb-6">
          <div class="col-lg-4 col-md-8 col-12 pl-0 ml-0 mb-3 mb-md-2">
            <button type="button" @click="selectAll()" style="background-color: #23546d;" class="float-left btn text-white btn-lg btn-block">Selecionar todos</button>    
          </div>
          <div class="col-lg-4 col-md-8 pl-0 ml-0">
            <button type="button" @click="clear()" style="background-color: #23546d;" class="float-left btn text-white btn-lg btn-block">Limpar</button>
          </div>
          <div class="col-lg-2 col-md-8 pl-0 ml-0">
            <button type="button" @click="voltar()" style="background-color: #23546d;" class="float-left btn text-white btn-lg btn-block">Voltar</button>
          </div>
        </div>
        <div class="d-flex justify-content-end col-lg-3 col-5" style="">
          <a @click="negociarAVista()" class="btn btn-secondary text-white btn-lg btn-block" style="background-color: #45c7a2; border: none; cursor: pointer;">Simular este contrato<i class="fa fa-fw fa-chevron-right"></i></a>
        </div>
      </div>
      <div class="row col justify-content-between">
        <h4 class="text-danger pl-2 col-8">Valor total {{ valueTotal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}</h4>
        <div class="row col-12 pl-4">
          <div class="row col-12">
            <svg height="100" width="100" style="max-width: 1.2rem; max-height: 1.9rem;">
              <circle cx="10" cy="15" r="6"
              fill="red"/>
            </svg>
            <h6 class="pt-2">Parcelas vencidas</h6>
          </div>
          <div class="row col-12">
            <svg 
            height="100" 
            width="100" 
            class="ml-mb-3"
            style="max-width: 1.2rem; max-height: 1.9rem;">
              <circle cx="10" cy="15" r="6"
              fill="yellow"/>
            </svg>
            <h6 class="pt-2">Parcelas a vencer</h6>
          </div>
        </div>
        <div class="col-12 pl-2" v-if="!loadDeal && contracts.length > 1 && showFilter">
          <input type="checkbox" v-model="showDueCont" @change="showDueContracts()">
          Exibir vencidos
          <input type="checkbox" class="ml-4" v-model="showPendingCont" @change="showPendingContracts()">
          Exibir pendentes
        </div>
      </div>
      <div class="row">
        <div v-bind:class="[ contracts.length <= 1 ? 'd-inline-flex flex-wrap flex-column col-lg-12 col-md-12 col-acao': 'd-inline-flex flex-wrap flex-column col-lg-6 col-md-12 col-acao' ]" 
          v-for="(value, key, index) in contracts"
          :key="`${key}-${index}`">
          <div class="card m-0" style="height: 30rem;">
            <div class="card-header">
              <i class="fa fa-fw mr-2 fa-circle text-secondary"></i>
              Contrato negociável
            </div>
            <div class="card-body pb-0">
              <div class="row">
                <div class="col-md-6 col-12">
                  <h6>Produto: {{ value.produto }}</h6>
                  <p class="m-0">Contrato: {{ value.contrato }}</p>
                </div>
                <div class="col-md-6 col-6">
                  <p class="m-0 text-info">Valor total</p>
                  <h6>{{ valueByContract[value.contrato].toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }).replace("-","") }}</h6>
                </div>
              </div>
              <br>
              <div class="row table-h-100" v-if="value.parcelas.length > 0"  :style="value.parcelas.length < 4 ? 'height: 5rem;' : 'height: 16rem; overflow-y: auto;'">
                <table class="table table-sm" width="100%"  cellspacing="0">
                  <thead class="" style="heigth: 29.8px !important;">
                    <tr class="small" style="max-heigth: 35.6px !important;">
                      <th style="text-align:center;">Selecionar</th>
                      <th>Número</th>
                      <th>Data Vencimento</th>
                      <th v-if="!isMobile()">Valor</th>
                    </tr>
                  </thead>
                  <tbody class="text-muted " >  
                    <tr v-for="(parcel, idx, index) in value.parcelas" heigth="29.8px"
                      :key="`${idx}-${index}`">       
                        <td style="text-align:center;">
                          <svg height="100" width="100" style="max-width: 2rem; max-height: 1.9rem;">
                            <circle cx="10" cy="15" r="6"
                            :fill="compareDates(formatData(parcel.vencimento, 'YYYY-MM-DD', 'L')) ? 'red' : 'yellow'"/>
                          </svg>
                          <input id="checkParcels" type="checkbox" 
                          v-model="checkedParcels" 
                          :value="parcel"
                          @change="calculateSingleInstallment(value.contrato, parcel)"
                          />
                        </td>
                      <td>{{ parcel.parcela }}</td>
                      <td>{{ formatData(parcel.vencimento,"YYYY-MM-DD","L")}}</td>
                      <td v-if="!isMobile()">R$ {{ parcel.valor }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="card-footer m-1 bg-white row align-items-center justify-content-around">
              <div class="col-8">
                <input type="checkbox" :value="value.contrato" v-model="selectedAll" @change="selectAllByContract(value)">
                Selecionar contrato
              </div>
              <a @click="negociarAVista()" class="btn btn-secondary text-white btn-lg btn-block col-4" style="background-color: #45c7a2; border: none;">Simular<i class="fa fa-fw fa-chevron-right"></i></a>
            </div>
          </div>     
        </div>
      </div>
    </div>
    <div class="container" v-if="loadDeal">
      <ProgressLoading v-bind:loading="loadDeal" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { formatCurrencieValueBRL as formatValue, formatData, parseBR } from "@/utils/helpers";
import ProgressLoading from "../../../modules/auth/components/ProgressLoading.vue";
export default {
    name: "HistoricoPagamentos",
    components: {
      ProgressLoading,
      //ContentMenu
    },
    data () {
        return {
            loadDeal: true,
            negociacao: null,
            selectDeal:null,
            selectedAll: [],
            digitalLine:null,
            checkSelectAll: false,
            checkContract: false,
            showFilter: true,
            validationError:false,
            valueByContract: {},
            showPendingCont:false,
            showDueCont:false,
            links: [],
            selected: {},
            dataAtual : new Date(Date.now()),
            offers: [],
            contracts:[],
            checkedParcels: [],
            checkedParcelsByContract: {},
            selectVariable: true,
            valueTotal: 0,
            largura: null
        }
    },
    methods: {
        formatValue,
        formatData,

        ...mapActions('minhasDividas', 
        [
          'ActionDividaNegociar',
          'ActionGetContractsNegotiable',
          'ActionSetContractsNegotiable',
          'ActionGetOffersTribanco'
        ]),

        isMobile() {
          if(parseInt(this.largura) > 500) return false
          return true
        },

        showDueContracts() {
          if (this.showDueCont && this.showPendingCont || !this.showDueCont && !this.showPendingCont) {
            this.contracts = JSON.parse(localStorage.getItem('contracts'))
            this.$forceUpdate()  
            return
          }
          if (this.showPendingCont && !this.showDueCont) {
            this.showPendingContracts()
            return
          }
          let filtered = this.contracts.filter((contract) => {
            return this.compareDates(formatData(contract.parcelas[0].vencimento, 'YYYY-MM-DD', 'L'))
          })
          this.contracts = filtered
          this.$forceUpdate()
        },

        showPendingContracts() { 
          if (this.showPendingCont && this.showDueCont || !this.showDueCont && !this.showPendingCont) {
            this.contracts = JSON.parse(localStorage.getItem('contracts'))
            this.$forceUpdate()  
            return
          }
          if (!this.showPendingCont && this.showDueCont) {
            this.showDueContracts()
            return
          }
          let filtered = this.contracts.filter((contract) => {
            return !this.compareDates(formatData(contract.parcelas[0].vencimento, 'YYYY-MM-DD', 'L'))
          })
          this.contracts = filtered
          this.$forceUpdate()
        },
        
        async selectAllByContract(contract) {

          contract.parcelas.map((installment) => {
            
            if (!this.selected[contract.contrato] && this.checkedParcels.includes(installment)) return
            else if (this.selected[contract.contrato] && !this.checkedParcels.includes(installment)) return
            else if (!this.selected[contract.contrato] && !this.checkedParcels.includes(installment)) {
              this.checkedParcels.push(installment)
            } else this.checkedParcels.splice(this.checkedParcels.indexOf(installment), 1)
            this.calculateSingleInstallment(contract.contrato, installment)
          })
          this.selected[contract.contrato] = !this.selected[contract.contrato] 
        },
        compareDates (date) {
          let parts = date.split('/') 
          let today = new Date()    
          date = new Date(parts[2], parts[1] - 1, parts[0])
          return today > date ? true : false;
        },
        calculateSingleInstallment(contract, parcel) {
          this.valueTotal = 0
          
          if (this.checkedParcels.length === 0) {
            this.valueByContract[contract] = 0
            this.checkedParcelsByContract[contract] = []
            return
          }
          if (this.checkedParcels.filter((value) => { return value === parcel }).length === 0) {
            this.checkedParcelsByContract[contract].splice(this.checkedParcelsByContract[contract].indexOf(parcel), 1)
            this.valueByContract[contract] -= parseBR(parcel.valor)
          } else {
            this.checkedParcelsByContract[contract].push(parcel)
            this.valueByContract[contract] += parseBR(parcel.valor)
          }

          this.checkedParcels.map((value) => {
            this.valueTotal += parseBR(value.valor)
          })
        },

        selectAll() {
          this.clear()

          this.contracts.map((contract) => {
            this.selectedAll.push(contract.contrato)
            this.selected[contract.contrato] = true
            contract.parcelas.map((installment) => {
              this.checkedParcelsByContract[contract.contrato].push(installment)
              this.checkedParcels.push(installment)
              this.valueTotal += parseBR(installment.valor)
              this.valueByContract[contract.contrato] += parseBR(installment.valor)
            })
          })
        },

        clear() {
          this.selectedAll = []
          this.checkedParcels = []
          this.valueTotal = 0
          this.contracts.map((contract) => {
            this.valueByContract[contract.contrato] = 0
            this.checkedParcelsByContract[contract.contrato] = []
          })
        },

        voltar() {
             this.$router.push({ 
              name: 'dashboard',
            });
        },

        checkInstallmentRules() {
          var result = true;
          const thisContracts = JSON.parse(localStorage.getItem('contracts'))
          Object.keys(this.checkedParcelsByContract).map((value) => {
              this.checkedParcelsByContract[value].sort(function(a, b) {
                return parseInt(a.parcela) - parseInt(b.parcela);
              });
              thisContracts.find((item) => {
                return item.contrato === value;
              }).parcelas.slice(0, this.checkedParcelsByContract[value].length).map((item2, index) => {
                if(item2.parcela !== this.checkedParcelsByContract[value][index].parcela) {
                  result = false;
                }
              });
          });

          return result;
          
        },

        async negociarAVista() {

          if (await !this.checkInstallmentRules()) {
            this.flashMessage.show({
                timeout: 1000,
                status: "error",
                blockClass: 'custom-block-class',
                title: "Ocorreu um erro",
                message: `Selecione parcela(s) em sequência!`,
              });
              return;
          }

          if(this.checkedParcels.length < 1) {
            this.flashMessage.show({
                timeout: 1000,
                status: "error",
                blockClass: 'custom-block-class',
                title: "Ocorreu um erro",
                message: `Selecione pelo menos 1 parcela para negociar!`,
              });
              return;
          }
          
          let installmentOption = true
          for (const key in this.checkedParcelsByContract) {
            if (this.checkedParcelsByContract[key].length > 0) {
              this.checkedParcelsByContract[key].total = this.valueByContract[key]
              const contractLenght = (this.contracts.filter((item) => {
                return item.contrato === key
              }))[0].parcelas.length
              const keyLenght = this.checkedParcelsByContract[key].length

              if (keyLenght > 0 && keyLenght !== contractLenght) installmentOption = false

            } else delete this.checkedParcelsByContract[key]
          }
          localStorage.setItem('selectedContractsToUpdate', JSON.stringify(this.checkedParcelsByContract))
          this.$router.push({
              name: "negociar",
              params: { contracts: this.checkedParcelsByContract, installmentOption },
          });
        }

    },
    async created() {
      this.largura = window.screen.width; 
      let contractsFromLocalStorage = JSON.parse(localStorage.getItem("selectedContracts"))
      this.contracts = Array.isArray(contractsFromLocalStorage) && contractsFromLocalStorage !== null ? contractsFromLocalStorage : this.voltar();
      this.contracts = this.contracts.filter((contract) => {
        this.selected[contract.contrato] = false
        this.valueByContract[contract.contrato] = 0
        this.checkedParcelsByContract[contract.contrato] = []
        return contract.produto !== 'PARC'
      })
      this.showFilter = this.$route.params.showFilter;

      this.loadDeal = false;
    },
    computed: {
      ...mapState("auth", ["user"]),
      isLoggedIn() {
      return this.$store.getters["auth/isLoggedIn"];
    },
    }
};
</script>
<style scoped>
/* 
a:hover {
  background-color: #31a07f;
} */




</style>
